import { EventCondensed } from '@core/models/tickets/Ticket';
import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import { EventType } from '@core/models/tickets/enums';
import LottoOdd from '@core/models/lotto/LottoOdd';

export default class LottoTicketEventMapper extends AbstractMapper<any, EventCondensed> {
    // TODO: Dino should check this
    createTargetObject(origin: any) {
        const e = {} as EventCondensed;
        e.date = this.toDate(origin.eventDate);
        e.name = this.extractLocalizedString(origin.name);
        e.odd = createOdd(origin.odds[origin.selections.length - 1].value, origin.selection);
        e.marketing = '';
        e.eventId = origin.eventId;
        e.type = '' as EventType;
        e.inputCode = createInutCode();
        return e;
    }
}

const createOdd = (odd: LottoOdd, name: string) => ({
    name,
    coefficient: odd.value,
    systemGroupName: '',
    isFix: false,
    specialValue: '',
    oddId: '',
    marketName: '',
});

const createInutCode = () => ({
    event: '',
    market: '',
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/tickets/LottoTicketEventMapper.ts